import * as React from 'react';
import { useParams } from 'react-router-dom';
import { P } from '../../../designSystem/typography/Body';
import { clientAccessHelper } from '../../../utils/clientAccessHelper';
import { ProtectedPageContext } from '../../_contexts/ProtectedPageContext';
import { MemberPageWrapper } from '../../_pageWrappers/MemberPageWrapper';
import MeetingActivityPageView from '../../_components/activities/MeetingActivityPageView';

export default function AnnualWorkgroupStatusPage(): JSX.Element {
    const [activityTitle, setActivityTitle] = React.useState('');
    
    return (
        <MemberPageWrapper
            selectedMenuItemKey="annualworkgroupstatus"
            breadCrumbs={[
                {text:'Årlige drøftelser', url:'/annualworkgroupstatus'},
                ...(activityTitle ? [{text:activityTitle, url:''}] : [])
            ]}>
            <AnnualWorkgroupStatusPageContent onActivityTitleChanged={setActivityTitle} />
        </MemberPageWrapper>
    );
}

type AnnualWorkgroupStatusPageContentProps = {
    onActivityTitleChanged:(title:string) => void,
}

function AnnualWorkgroupStatusPageContent(props:AnnualWorkgroupStatusPageContentProps): JSX.Element
{
    const params = useParams<{ activityId: string }>();
    const activeUser = React.useContext(ProtectedPageContext).user;
    const hasAccess = clientAccessHelper.hasAllPermissions(activeUser, ['ViewActivity']);

    if (!hasAccess)
        return <P>Hov! Du har ikke rettigheder til at tilgå denne side.</P>;

    return params.activityId 
        ? <MeetingActivityPageView activityId={params.activityId} onActivityTitleChanged={props.onActivityTitleChanged} />
        : <span>ugyldig url</span>;
}
